import request from '@/utils/request';


// 获取个人邮箱
export function GetMyMail() {
  return request({
    url: '/api/user/info/getMyMail',
    method: 'GET',
  });
}

// 发送邮箱验证码
export function SendCodeToMail(data) {
  return request({
    url: '/api/user/info/sendCodeToMail',
    method: 'POST',
    data,
  });
}

// 修改邮箱
export function ChangeMail(data) {
  return request({
    url: '/api/user/info/changeMail',
    method: 'POST',
    data
  });
}

// 获取个人手机号
export function GetMyMobile() {
  return request({
    url: '/api/user/info/getMyMobile',
    method: 'GET',
  });
}

// 发送邮箱验证码
export function SendCodeToMobile(data) {
  return request({
    url: '/api/user/info/sendCodeToMobile',
    method: 'POST',
    data,
  });
}

// 修改邮箱
export function ChangeMobile(data) {
  return request({
    url: '/api/user/info/changeMobile',
    method: 'POST',
    data
  });
}

// 获取个人信息
export function GetInfo() {
  return request({
    url: '/api/user/info/getInfo',
    method: 'GET',
  });
}

// 提交信息
export function EditInfo(data) {
  return request({
    url: '/api/user/info/editInfo',
    method: 'POST',
    data
  });
}

// 修改密码
export function SetLoginPwd(data) {
  return request({
    url: '/api/user/info/setLoginPwd',
    method: 'POST',
    data
  });
}

// 获取帐户列表
export function GetAccountList(params) {
  return request({
    url: '/api/user/info/accountList',
    method: 'GET',
    params: params
  });
}